// extracted by mini-css-extract-plugin
export default {"root":"_203qBLJZ4LuYGN2gpn8d3g=="};